
import { Button, Divider, Grid, Typography } from "@mui/material";
import * as Yup from 'yup';

import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import { IEntityToDisable } from "../models/entityToDisable";
import '../themes/styles.css';

interface Props {
    onCancel: () => void,
    onOk: (id: number, quantity?: number) => void
    entity: IEntityToDisable,
    isAdding?: boolean
}

export const MyConfirmDialog = ({ onCancel, onOk, entity, isAdding }: Props) => {

    const onRemove = (values: any) => {
        onOk(entity.id);
        onCancel();
    }
    const onSave = (values: any) => {
        onOk(entity.id, values.quantity);
        onCancel();
    }

    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                {entity.name}
            </Typography>
            <br />
            <Divider />
            <br />

            {isAdding ?
                <Formik
                    initialValues={entity}
                    onSubmit={(values) => {
                        console.log("first");
                        onSave(values as any);
                        onCancel();
                    }}
                    validationSchema={Yup.object({
                        quantity: Yup.string().matches(
                            /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
                            "Only accept numbers")
                            .required('Required')
                    })}
                >
                    {(formik) => (
                        <Form>
                            <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item xs={6}>
                                    <Typography component="label" htmlFor="quantity">Quantity</Typography>
                                    <Field name="quantity" type="text" className={'error'} />
                                    {formik.errors.quantity && <div className="error-message">{formik.errors.quantity}</div>}
                                    <br />
                                </Grid>
                            </Grid>
                            <br />
                            <Grid container justifyContent="center">
                                <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                                &nbsp;&nbsp;&nbsp;
                                <Button variant="contained" type="submit" sx={{ width: 100 }} onClick={() => formik.validateField('quantity')}>Save</Button>
                            </Grid>
                        </Form>
                    )}
                </Formik>
                :
                <>
                    <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={6}>
                            <Typography component="label" htmlFor="availableQuantity">Do you want to do this action?</Typography>
                        </Grid>
                    </Grid>
                    <br />
                    <Grid container justifyContent="center">
                        <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button variant="contained" type="submit" sx={{ width: 100 }} onClick={onRemove}>Save</Button>
                    </Grid>
                </>
            }
        </Grid >
    )
}
